var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown } from '@patternfly/react-core/dist/dynamic/components/Dropdown';
import { DropdownItem } from '@patternfly/react-core/dist/dynamic/components/Dropdown';
import { DropdownList } from '@patternfly/react-core/dist/dynamic/components/Dropdown';
import { MenuToggle } from '@patternfly/react-core/dist/dynamic/components/MenuToggle';
import { Tooltip } from '@patternfly/react-core/dist/dynamic/components/Tooltip';
import React, { useState } from 'react';
import ExportIcon from '@patternfly/react-icons/dist/dynamic/icons/export-icon';
var DownloadButton = function (_a) {
    var _b = _a.extraItems, extraItems = _b === void 0 ? [] : _b, _c = _a.onSelect, onSelect = _c === void 0 ? function () { return undefined; } : _c, isDisabled = _a.isDisabled, _d = _a.tooltipText, tooltipText = _d === void 0 ? 'Export data' : _d, _e = _a.itemTexts, itemTexts = _e === void 0 ? {
        csv: undefined,
        json: undefined,
    } : _e, props = __rest(_a, ["extraItems", "onSelect", "isDisabled", "tooltipText", "itemTexts"]);
    var _f = useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var internalOnSelect = function () { return setIsOpen(function (prev) { return !prev; }); };
    var conditionallyTooltip = function (children) {
        return _jsx(React.Fragment, { children: tooltipText ? _jsx(Tooltip, { content: tooltipText, children: children }) : children });
    };
    return (_jsx(React.Fragment, { children: conditionallyTooltip(_jsx(Dropdown, __assign({}, props, { onOpenChange: function (isOpen) { return setIsOpen(isOpen); }, onSelect: internalOnSelect, toggle: function (toggleRef) { return (_jsx(MenuToggle, { "aria-label": "Export", variant: "plain", ref: toggleRef, isExpanded: isOpen, onClick: function () { return setIsOpen(function (prev) { return !prev; }); }, icon: _jsx(ExportIcon, {}) })); }, isOpen: isOpen, ouiaId: "Export", popperProps: { appendTo: 'inline' }, children: _jsxs(DropdownList, { children: [_jsx(DropdownItem, { ouiaId: "DownloadCSV", component: "button", onClick: function (event) { return onSelect(event, 'csv'); }, isDisabled: isDisabled, "aria-label": itemTexts.csv || 'Export to CSV', children: itemTexts.csv || 'Export to CSV' }, "download-csv"), _jsx(DropdownItem, { "aria-label": itemTexts.json || 'Export to JSON', ouiaId: "DownloadJSON", component: "button", onClick: function (event) { return onSelect(event, 'json'); }, isDisabled: isDisabled, children: itemTexts.json || 'Export to JSON' }, "download-json"), extraItems] }) }))) }));
};
export default DownloadButton;
//# sourceMappingURL=DownloadButton.js.map